import { render, staticRenderFns } from "./join-project-modal.vue?vue&type=template&id=a0602ea4&scoped=true&"
import script from "./join-project-modal.vue?vue&type=script&lang=js&"
export * from "./join-project-modal.vue?vue&type=script&lang=js&"
import style0 from "./join-project-modal.vue?vue&type=style&index=0&id=a0602ea4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0602ea4",
  null
  
)

export default component.exports